module.exports = __webpack_public_path__ + "static/media/theater-masks.e2a679c3.svg";